import { subYears } from 'date-fns';

import { FILTER_KEYS } from 'src/components/followUp/hooks/constants';
import type { RequiredDateRange } from 'src/components/myFollowUp/MyFollowUpPage/Sidebar/helper';
import { dateRangeToFilter } from 'src/components/myFollowUp/MyFollowUpPage/Sidebar/helper';
import type { DateRange } from 'src/components/ui/DateRangePicker';

/**
 * The committed comparison period.
 * The survey's configured defaults win; a legacy survey without them compares against the current period one
 * year earlier.
 */
export const comparisonDateRangeFilter = (
  defaultComparisonDateRange: DateRange | undefined,
  currentDateRange: RequiredDateRange,
) =>
  dateRangeToFilter(
    {
      startDate:
        defaultComparisonDateRange?.startDate ??
        subYears(currentDateRange.startDate, 1),
      endDate:
        defaultComparisonDateRange?.endDate ??
        subYears(currentDateRange.endDate, 1),
    },
    FILTER_KEYS.DATE_RANGE_COMPARISON,
  );
